import { Building2 } from "lucide-react";
import { UnifiedRecord, SystemMetrics } from "../../../types";
import { BedMap } from "../../Dashboard/BedMap";
import { BottleneckPanel } from "../../Dashboard/BottleneckPanel";
import { HealthSchemeRegistration } from "../../Dashboard/HealthSchemeRegistration";

interface DashboardProps {
  records: UnifiedRecord[];
  metrics: SystemMetrics | null;
  loading: boolean;
}

export function DeskDashboard({ records }: DashboardProps) {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-3 mb-4 border-b border-white/10 pb-4">
        <Building2 className="w-8 h-8 text-amber-400" />
        <div>
          <h2 className="text-xl font-semibold text-white">Front Desk & Bed Management</h2>
          <p className="text-gray-400 text-sm">Real-time bed tracking and transfers</p>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        <div className="xl:col-span-2">
          <BedMap records={records} />
          <HealthSchemeRegistration />
        </div>
        <div>
          <BottleneckPanel records={records} />
        </div>
      </div>
    </div>
  );
}
